import api from 'lib/trpcClient';
import { TagName } from 'further-types/tag';

const useIsSyndicate = (tagId: string | undefined): boolean => {
  const tags = api.eisTag.list.useQuery({});
  const selectedTag = tags.data?.find((t) => t.id === tagId);
  return (
    (selectedTag?.isSyndicate ?? false) || selectedTag?.name === TagName.Direct
  );
};

export default useIsSyndicate;
